<template>
  <div class="py-3 px-4 flex items-center">
    <div class="flex-1">
      {{ deal.description }}
      <span
        class="ml-1 hidden md:inline"
        :class="subtle ? 'text-gray-400' : 'text-gray-600'"
        v-if="deal.amount"
      >t.w.v. {{ deal.amount | formatMoney }}</span>
    </div>
    <div v-if="isPending">
      <div v-if="deal.phase" class="flex items-center" v-tooltip="tooltip">
        <div class="w-2 h-2 rounded-full mr-2" :class="subtle ? 'bg-orange-300' : 'bg-orange-400'"></div>
        <div>{{ deal.phase.name }}</div>
      </div>
    </div>
    <div v-else>
      <div class="flex items-center" v-tooltip="tooltip">
        <div
          v-if="isWon"
          class="w-2 h-2 rounded-full mr-2"
          :class="subtle ? 'bg-green-300' : 'bg-green-500'"
        ></div>
        <div v-else class="w-2 h-2 rounded-full mr-2" :class="subtle ? 'bg-red-300' : 'bg-red-500'"></div>
        <div>{{ closedAt }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";

export default {
  props: {
    deal: {
      type: Object,
      required: true
    },
    subtle: {
      type: Boolean
    },
    noTooltips: {
      type: Boolean
    }
  },

  computed: {
    isPending() {
      return this.deal.result == "pending";
    },

    isWon() {
      return this.deal.result == "won";
    },

    closedAt() {
      let date = this.deal.closed_at;
      let month = dayjs(date).month();
      let quarter = Math.floor(month / 3) + 1;
      let year = dayjs(date).year();

      return `Q${quarter} ${year}`;
    },

    tooltip() {
      if (this.noTooltips) return;

      let user = this.deal.user || {};

      if (this.isPending) {
        return `${user.name_short} werkt aan deze deal`;
      } else if (this.isWon) {
        return `Gewonnen door ${user.name_short}`;
      } else {
        return `Verloren door ${user.name_short}`;
      }
    }
  }
};
</script>